import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const EmptyState: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-16 px-8">
            <div
                className="w-24 h-24 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 rounded-full flex items-center justify-center mb-6 shadow-inner">
                <FontAwesomeIcon
                    icon={faBalanceScale}
                    className="text-3xl text-gray-400 dark:text-gray-500"
                />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                {t('components.emptyState.noExpensesYet')}
            </h3>
            <p className="text-gray-600 dark:text-gray-400 text-center max-w-md leading-relaxed">
                {t('components.emptyState.addExpensesToSee')}
            </p>
        </div>
    );
};

export default EmptyState;